export default "__VITE_ASSET__81a8c3c7__"